!(function () {
  var e = {
      1727: function () {
        class e extends HTMLElement {
          constructor() {
            (super(),
              (this.elements = {
                input: this.querySelector(
                  'input[name="locale_code"], input[name="country_code"]',
                ),
                details: this.querySelector("details"),
                summary: this.querySelector("summary"),
                links: this.querySelectorAll("ul a"),
              }),
              this.elements.links.forEach((e) =>
                e.addEventListener("click", this.onItemClick.bind(this)),
              ),
              (this.handleClickOutside = this.handleClickOutside.bind(this)),
              document.addEventListener("click", this.handleClickOutside),
              (this.handleKeyDown = this.handleKeyDown.bind(this)),
              this.elements.summary?.addEventListener(
                "keydown",
                this.handleKeyDown,
              ),
              (this.handleDetailsToggle = this.handleDetailsToggle.bind(this)),
              this.elements.details?.addEventListener(
                "toggle",
                this.handleDetailsToggle,
              ));
          }
          onItemClick(e) {
            e.preventDefault();
            const t = this.querySelector("form");
            ((this.elements.input.value = e.currentTarget.dataset.value),
              t && t.submit());
          }
          handleClickOutside(e) {
            this.elements.details &&
              this.elements.details.hasAttribute("open") &&
              !this.contains(e.target) &&
              this.closeDetails();
          }
          handleKeyDown(e) {
            if (!this.elements.details) return;
            if (
              "Escape" === e.key &&
              this.elements.details.hasAttribute("open")
            )
              return (
                e.preventDefault(),
                this.closeDetails(),
                void this.elements.summary?.focus()
              );
            if (!this.elements.details.hasAttribute("open"))
              return void (" " === e.key || e.key);
            const t = Array.from(this.elements.links).indexOf(
              document.activeElement,
            );
            switch (e.key) {
              case "ArrowDown":
                e.preventDefault();
                const i = t < this.elements.links.length - 1 ? t + 1 : 0;
                this.elements.links[i]?.focus();
                break;
              case "ArrowUp":
                e.preventDefault();
                const n = t > 0 ? t - 1 : this.elements.links.length - 1;
                this.elements.links[n]?.focus();
                break;
              case "Home":
                (e.preventDefault(), this.elements.links[0]?.focus());
                break;
              case "End":
                (e.preventDefault(),
                  this.elements.links[this.elements.links.length - 1]?.focus());
                break;
              case "Escape":
                (e.preventDefault(),
                  this.closeDetails(),
                  this.elements.summary?.focus());
            }
          }
          handleDetailsToggle() {
            this.elements.details.hasAttribute("open")
              ? this.elements.links.forEach((e) => {
                  (e.addEventListener("keydown", this.handleKeyDown),
                    e.setAttribute("tabindex", "0"));
                })
              : this.elements.links.forEach((e) => {
                  (e.removeEventListener("keydown", this.handleKeyDown),
                    e.setAttribute("tabindex", "-1"));
                });
          }
          closeDetails() {
            this.elements.details &&
              this.elements.details.removeAttribute("open");
          }
          disconnectedCallback() {
            (document.removeEventListener("click", this.handleClickOutside),
              this.elements.summary?.removeEventListener(
                "keydown",
                this.handleKeyDown,
              ),
              this.elements.details?.removeEventListener(
                "toggle",
                this.handleDetailsToggle,
              ),
              this.elements.links.forEach((e) => {
                e.removeEventListener("keydown", this.handleKeyDown);
              }));
          }
        }
        customElements.get("localization-form") ||
          customElements.define("localization-form", e);
      },
      4487: function (e, t, i) {
        "use strict";
        var n = i(6072);
        const r = new (class {
          constructor() {
            ((this.selectorsToUpdate = [
              ".cart-summary__header",
              ".cart-summary__line-items",
              "#checkout",
              ".cart-summary__free-shipping",
            ]),
              (this.mainCartSelector = ".shopify-section.cart"),
              (this.miniCart = document.getElementById("mini-cart")),
              (this.itemsContainersSelector =
                ".cart-items-container, .cart__empty, .mini-cart--empty"),
              (this.parser = new DOMParser()),
              (this._desiredQtyByKey = new Map()),
              (this._inFlightByKey = new Set()),
              (this._inventoryBlockedByKey = new Set()),
              (this._maxQtyByKey = new Map()),
              (this._errorTimeoutByKey = new Map()),
              (this._versionByKey = new Map()),
              (this._deletingByKey = new Set()),
              (this.debugMode = !0),
              (this._needsCartRefresh = !1),
              (this.selectors = {
                cartItem: ".cart-item",
                cartItemTotals: ".cart-item__totals",
                priceItemSale: ".price-item--sale",
                priceItemRegular: ".price-item--regular",
                cartItemsContainer: ".cart-items-container",
                miniCart: "#mini-cart",
              }),
              (this.items = Array.from(
                document.querySelectorAll(".cart-item"),
              )),
              this.items.forEach((e) => this.manageState(e)));
          }
          _getCartContainers() {
            const e = [],
              t = document.querySelector(this.mainCartSelector);
            t && e.push({ container: t, name: "mainCart", searchContainer: t });
            const i = document.getElementById("mini-cart");
            if (i) {
              const t = i.querySelector(this.selectors.cartItemsContainer);
              e.push({
                container: i,
                name: "miniCart",
                searchContainer: t || i,
              });
            }
            return e;
          }
          requestQuantityUpdate(e, t) {
            this._desiredQtyByKey.set(e, t);
            const i = this._versionByKey.get(e) || 0;
            this._versionByKey.set(e, i + 1);
            const n = this._maxQtyByKey.get(e);
            (this._inventoryBlockedByKey.has(e) &&
              void 0 !== n &&
              t <= n &&
              (this._inventoryBlockedByKey.delete(e),
              this.clearInventoryError(e)),
              this._inFlightByKey.has(e) || this._processItemUpdate(e));
          }
          async _processItemUpdate(e) {
            this._inFlightByKey.add(e);
            const t = this._desiredQtyByKey.get(e),
              i = this._versionByKey.get(e),
              n = document.querySelector(`.cart-item[data-item-id="${e}"]`);
            if (!n)
              return (
                this._inFlightByKey.delete(e),
                void this._desiredQtyByKey.delete(e)
              );
            const r = n.getAttribute("data-variant-id");
            this._setItemBusy(n, !0);
            try {
              (await this.changeCartItem({
                id: r,
                quantity: t,
                itemKey: e,
                requestVersion: i,
              }),
                this.clearInventoryError(e),
                this._inventoryBlockedByKey.delete(e));
            } catch (t) {
              if ((console.error("Cart update failed:", t), 429 === t.status))
                await new Promise((e) => setTimeout(e, 300));
              else if (422 === t.status) {
                try {
                  const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
                    i = await fetch(t),
                    n = await i.text(),
                    r = this.parser.parseFromString(n, "text/html"),
                    s = r.querySelector(`.cart-item[data-item-id="${e}"]`);
                  if (s) {
                    const t = s.querySelector('input[name="quantity"]'),
                      i = (t && parseInt(t.value)) || 1;
                    (this._maxQtyByKey.set(e, i),
                      this._desiredQtyByKey.set(e, i),
                      this._inventoryBlockedByKey.add(e),
                      this.showInventoryError(e, `Only ${i} available`),
                      await this.patchLineItem(e, r),
                      this.renderElements(r),
                      this.restoreOptimisticQuantities());
                  }
                } catch (e) {
                  console.error("Failed to fetch cart section after 422:", e);
                }
                return (
                  this._setItemBusy(n, !1),
                  void this._inFlightByKey.delete(e)
                );
              }
            } finally {
              (this._setItemBusy(n, !1), this._inFlightByKey.delete(e));
              const i = this._desiredQtyByKey.get(e);
              void 0 !== i && i !== t && this._processItemUpdate(e);
            }
          }
          _setItemBusy(e, t) {
            e &&
              [
                e.querySelector('button[name="plus"]'),
                e.querySelector('button[name="minus"]'),
                e.querySelector('input[name="quantity"]'),
              ].forEach((e) => {
                e &&
                  (t
                    ? e.classList.add("is-busy")
                    : e.classList.remove("is-busy"));
              });
          }
          async patchLineItem(e, t) {
            let i =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            try {
              if (!t)
                return void console.error(
                  `[Cart] patchLineItem: parsedSection is null/undefined for ${e}`,
                );
              const n = t.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              if (!n && !i)
                return void console.warn(
                  `[Cart] patchLineItem: Server item not found for key ${e} and no manual calc data`,
                );
              let r = null;
              if (
                n &&
                ((r = n.querySelector(this.selectors.cartItemTotals)), !r && !i)
              )
                return void console.warn(
                  `[Cart] patchLineItem: Server totals not found for key ${e}`,
                );
              if (i) {
                const n = this._getCartContainers();
                let s = null,
                  a = null;
                for (const { searchContainer: t, name: i } of n) {
                  const i = t.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${e}"]`,
                  );
                  if (i) {
                    let e = i.querySelector(
                        ".text-md.show-desktop " + this.selectors.priceItemSale,
                      ),
                      t = i.querySelector(".text-md.show-desktop s");
                    if (
                      ((e && t) ||
                        ((e = i.querySelector(
                          ".text-md " + this.selectors.priceItemSale,
                        )),
                        (t = i.querySelector(".text-md s"))),
                      !e || !t)
                    ) {
                      const n = i.querySelectorAll(
                        this.selectors.priceItemSale,
                      );
                      for (const i of n)
                        if (!i.closest(this.selectors.cartItemTotals)) {
                          e = i;
                          const n = i.closest("dl, div");
                          n && (t = n.querySelector("s"));
                          break;
                        }
                    }
                    if (e && t) {
                      ((s = e.textContent.trim()), (a = t.textContent.trim()));
                      break;
                    }
                  }
                }
                if (s && a) {
                  const e = (e) => {
                      const t = e.replace(/[^\d.,]/g, "");
                      if (t.includes(",") && !t.includes("."))
                        return parseFloat(t.replace(",", "."));
                      if (t.includes(",") && t.includes(".")) {
                        const e = t.split(",");
                        if (2 === e.length && e[1].length <= 2)
                          return parseFloat(
                            t.replace(/\./g, "").replace(",", "."),
                          );
                      }
                      return parseFloat(t.replace(/,/g, ""));
                    },
                    n = (e(s), e(a) * i.requestedQty),
                    o = i.calculatedLinePrice,
                    c = (e) => {
                      const t = s.match(/[\d,]+\.?\d*/);
                      if (!t) return e.toFixed(2);
                      const i = t[0],
                        n = s.substring(0, s.indexOf(i)),
                        r = s.substring(s.indexOf(i) + i.length),
                        a =
                          s.includes(",") &&
                          (!s.includes(".") || s.indexOf(",") > s.indexOf(".")),
                        o =
                          i.includes(".") || i.includes(",")
                            ? i.split(/[.,]/)[1]?.length || 2
                            : 0;
                      let c = e.toFixed(o);
                      if (a) {
                        c = c.replace(".", ",");
                        const e = c.split(",");
                        (e[0].length > 3 &&
                          (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")),
                          (c = e.join(",")));
                      } else {
                        const e = c.split(".");
                        (e[0].length > 3 &&
                          (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")),
                          (c = e.join(".")));
                      }
                      return n + c + r;
                    },
                    l = `\n            <span class="text-xs show-mobile">Subtotal</span>\n            <span class="total-price">\n              <dl>\n                <dt class="visually-hidden">Regular price</dt>\n                <dd class="price-item--regular">\n                  <s class="text-xs">${c(n)}</s>\n                </dd>\n                <dt class="visually-hidden">Sale price</dt>\n                <dd class="price-item--sale">${c(o)}</dd>\n              </dl>\n            </span>\n          `;
                  r ? (r.innerHTML = l) : (t._calculatedTotalsHTML = l);
                } else
                  console.warn(
                    "[Cart] Could not find per-unit prices for manual calculation",
                  );
              }
              if (!r && !t._calculatedTotalsHTML)
                return void console.warn(
                  "[Cart] patchLineItem: Cannot proceed without serverTotals or calculated HTML",
                );
              let s = null;
              (r
                ? (s = r.innerHTML)
                : t._calculatedTotalsHTML && (s = t._calculatedTotalsHTML),
                this._getCartContainers().forEach((i) => {
                  let { searchContainer: a, name: o } = i;
                  const c = a.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${e}"]`,
                  );
                  if (!c) return;
                  const l = c.querySelector(this.selectors.cartItemTotals);
                  if (l && s) {
                    let e = null,
                      i = null;
                    if (r)
                      ((e = r.querySelector(this.selectors.priceItemSale)),
                        (i = r.querySelector(this.selectors.priceItemRegular)));
                    else if (t._calculatedTotalsHTML) {
                      const n = document.createElement("div");
                      ((n.innerHTML = t._calculatedTotalsHTML),
                        (e = n.querySelector(this.selectors.priceItemSale)),
                        (i = n.querySelector(this.selectors.priceItemRegular)));
                    }
                    const n = l.querySelector(this.selectors.priceItemSale),
                      a = n?.textContent.trim() || null,
                      o =
                        l
                          .querySelector(this.selectors.priceItemRegular)
                          ?.textContent.trim() || null,
                      c = e?.textContent.trim() || null,
                      d = i?.textContent.trim() || null;
                    (a !== c || o !== d || n || e || !n) &&
                      ((l.innerHTML = s),
                      l
                        .querySelectorAll(".icon")
                        .forEach((e) => e.classList.add("loaded")));
                  } else
                    l ||
                      console.warn(
                        `[Cart] patchLineItem: Current totals not found for key ${e} in ${o}`,
                      );
                  if (n) {
                    const e = c.querySelector(".cart-item__discounts"),
                      t = n.querySelector(".cart-item__discounts");
                    if (t)
                      if (e)
                        ((e.innerHTML = t.innerHTML),
                          e
                            .querySelectorAll(".icon")
                            .forEach((e) => e.classList.add("loaded")));
                      else {
                        const e = c.querySelector(".cart-item__title");
                        if (e) {
                          const i = t.cloneNode(!0);
                          (e.appendChild(i),
                            i
                              .querySelectorAll(".icon")
                              .forEach((e) => e.classList.add("loaded")));
                        }
                      }
                    else e && e.remove();
                  }
                }));
            } catch (t) {
              (console.error(`[Cart] Error in patchLineItem for ${e}:`, t),
                console.error("[Cart] Error stack:", t.stack));
            }
          }
          restoreOptimisticQuantities() {
            this._desiredQtyByKey.forEach((e, t) => {
              this._inventoryBlockedByKey.has(t) ||
                this._getCartContainers().forEach((i) => {
                  let { searchContainer: n } = i;
                  const r = n.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${t}"]`,
                  );
                  if (!r) return;
                  const s = r.querySelector('input[name="quantity"]');
                  if (!s) return;
                  const a = this._maxQtyByKey.get(t),
                    o = void 0 !== a ? Math.min(e, a) : e;
                  (parseInt(s.value) || 1) !== o && (s.value = o);
                });
            });
          }
          showInventoryError(e, t) {
            const i = this._errorTimeoutByKey.get(e);
            (i && clearTimeout(i),
              this._getCartContainers().forEach((i) => {
                let { searchContainer: n } = i;
                const r = n.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (!r) return;
                const s = r.querySelector(".cart-item__error");
                s && ((s.textContent = t), (s.style.display = "block"));
              }));
            const n = setTimeout(() => {
              const i = this._desiredQtyByKey.get(e),
                n = this._maxQtyByKey.get(e);
              void 0 === i || void 0 === n || i <= n
                ? this.clearInventoryError(e)
                : this.showInventoryError(e, t);
            }, 4e3);
            this._errorTimeoutByKey.set(e, n);
          }
          clearInventoryError(e) {
            const t = this._errorTimeoutByKey.get(e);
            (t && (clearTimeout(t), this._errorTimeoutByKey.delete(e)),
              this._getCartContainers().forEach((t) => {
                let { searchContainer: i } = t;
                const n = i.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (!n) return;
                const r = n.querySelector(".cart-item__error");
                r && ((r.textContent = ""), (r.style.display = "none"));
              }));
          }
          _removeDeleteClass(e) {
            this._getCartContainers().forEach((t) => {
              let { searchContainer: i } = t;
              const n = i.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              n && n.classList.remove("is-deleting");
            });
          }
          _animateItemRemoval(e) {
            return new Promise((t) => {
              if (!e) return void t();
              if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
                return (e.remove(), void t());
              const i = e.offsetHeight;
              ((e.style.height = `${i}px`),
                (e.style.overflow = "hidden"),
                e.setAttribute("aria-live", "polite"),
                e.setAttribute("aria-atomic", "true"),
                e.offsetHeight,
                requestAnimationFrame(() => {
                  (e.classList.add("cart-item--removing"),
                    setTimeout(() => {
                      (e.remove(), t());
                    }, 300));
                }));
            });
          }
          removeEventListeners(e) {
            const t = e.querySelector(".cart-item-delete, .cart-item__remove"),
              i = e.querySelector('button[name="plus"]'),
              n = e.querySelector('button[name="minus"]'),
              r = e.querySelector('input[name="quantity"]');
            (t &&
              t._deleteHandler &&
              t.removeEventListener("click", t._deleteHandler),
              i &&
                i._clickHandler &&
                i.removeEventListener("click", i._clickHandler),
              n &&
                n._clickHandler &&
                n.removeEventListener("click", n._clickHandler),
              r &&
                (r._changeHandler &&
                  r.removeEventListener("change", r._changeHandler),
                r._keypressHandler &&
                  r.removeEventListener("keypress", r._keypressHandler)));
          }
          manageState(e) {
            this.removeEventListeners(e);
            const t = e.getAttribute("data-item-id"),
              i = e.getAttribute("data-variant-id"),
              n = e.getAttribute("data-max-qty");
            if (n && !this._maxQtyByKey.has(t)) {
              const e = parseInt(n);
              !isNaN(e) && e > 0 && this._maxQtyByKey.set(t, e);
            }
            const r = e.querySelector(".cart-item-delete, .cart-item__remove");
            if (r) {
              const e = async () => {
                if (this._deletingByKey.has(t))
                  this.debugMode &&
                    console.log(
                      `[Cart] Delete already in progress for ${t}, ignoring duplicate request`,
                    );
                else
                  try {
                    (this._deletingByKey.add(t),
                      this._getCartContainers().forEach((e) => {
                        let { searchContainer: i } = e;
                        const n = i.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${t}"]`,
                        );
                        n && n.classList.add("is-deleting");
                      }),
                      console.log(`[Cart] Starting delete for ${t}`),
                      console.log(
                        `[Cart] Fetching current cart state to find correct line number for ${t}`,
                      ));
                    const e = await fetch("/cart.js"),
                      n = (await e.json()).items.findIndex((e) => e.key === t);
                    if (-1 === n)
                      return (
                        console.warn(
                          `[Cart] Item ${t} not found in current cart, may already be deleted`,
                        ),
                        void this._getCartContainers().forEach((e) => {
                          let { searchContainer: i } = e;
                          const n = i.querySelector(
                            `${this.selectors.cartItem}[data-item-id="${t}"]`,
                          );
                          n && n.remove();
                        })
                      );
                    const r = n + 1;
                    let s;
                    console.log(
                      `[Cart] Item ${t} is at line ${r} (was stored as line ${i})`,
                    );
                    try {
                      ((s = await this.changeCartItem({ id: r, quantity: 0 })),
                        console.log(
                          "[Cart] Delete request successful, response:",
                          s,
                        ));
                    } catch (e) {
                      if (
                        (console.error(
                          `[Cart] changeCartItem failed for ${t}:`,
                          e,
                        ),
                        429 !== e.status)
                      )
                        return 422 === e.status
                          ? (console.error(
                              `[Cart] Server validation error (422) for ${t} - item NOT deleted, keeping in cart`,
                            ),
                            void this._removeDeleteClass(t))
                          : (console.error(
                              `[Cart] Unexpected error for ${t} - item may still be in cart`,
                            ),
                            void this._removeDeleteClass(t));
                      (console.warn(
                        `[Cart] Rate limited (429) for ${t}, waiting 500ms then retrying...`,
                      ),
                        await new Promise((e) => setTimeout(e, 500)));
                      try {
                        ((s = await this.changeCartItem({
                          id: i,
                          quantity: 0,
                        })),
                          this.debugMode &&
                            console.log(
                              `[Cart] Retry after rate limit successful for ${t}`,
                            ));
                      } catch (e) {
                        return (
                          console.error(`[Cart] Retry failed for ${t}:`, e),
                          void this._removeDeleteClass(t)
                        );
                      }
                    }
                    if (s) {
                      const e = 0 === s.item_count;
                      this.debugMode &&
                        console.log(
                          `[Cart] Removing item ${t} from all containers (${s.item_count} items remain, isLastItem: ${e})`,
                        );
                      const i = this._getCartContainers();
                      this.debugMode &&
                        console.log(
                          `[Cart] Found ${i.length} cart containers to update`,
                        );
                      const n = i.map((e) => {
                        let { searchContainer: i, name: n } = e;
                        const r = i.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${t}"]`,
                        );
                        return r
                          ? (this.debugMode &&
                              console.log(
                                `[Cart] Removing item ${t} from ${n}`,
                              ),
                            this._animateItemRemoval(r))
                          : (this.debugMode &&
                              console.log(`[Cart] Item ${t} not found in ${n}`),
                            Promise.resolve());
                      });
                      (await Promise.all(n),
                        this._desiredQtyByKey.delete(t),
                        this._inFlightByKey.delete(t),
                        this._inventoryBlockedByKey.delete(t),
                        this._maxQtyByKey.delete(t),
                        this._versionByKey.delete(t));
                      const r = this._errorTimeoutByKey.get(t);
                      (r &&
                        (clearTimeout(r), this._errorTimeoutByKey.delete(t)),
                        e &&
                          this.debugMode &&
                          console.log(
                            "[Cart] Last item removed, empty state should be visible",
                          ));
                    } else
                      console.error(
                        "[Cart] Delete operation failed - no response received",
                      );
                  } catch (e) {
                    console.error(`[Cart] Error deleting item ${t}:`, e);
                  } finally {
                    (this._deletingByKey.delete(t),
                      this.debugMode &&
                        console.log(
                          `[Cart] Delete operation completed for ${t}`,
                        ));
                  }
              };
              ((r._deleteHandler = e), r.addEventListener("click", e));
            }
            if (!e.querySelector('input[name="quantity"]')) return;
            const s = e.querySelector('button[name="plus"]'),
              a = e.querySelector('button[name="minus"]'),
              o = e.querySelector('input[name="quantity"]'),
              c = () => {
                const e = parseInt(o.value) || 1,
                  i = this._maxQtyByKey.get(t),
                  n = void 0 !== i ? Math.min(i, e + 1) : e + 1;
                n !== e || void 0 === i
                  ? ((o.value = n), this.requestQuantityUpdate(t, n))
                  : this.showInventoryError(t, `Only ${i} available`);
              },
              l = () => {
                const e = parseInt(o.value) || 1,
                  i = Math.max(1, e - 1);
                i !== e && ((o.value = i), this.requestQuantityUpdate(t, i));
              },
              d = (e) => {
                const i = parseInt(e.target.value);
                let n = isNaN(i) || i < 1 ? 1 : i;
                const r = parseInt(o.value) || 1,
                  s = this._maxQtyByKey.get(t);
                (void 0 !== s &&
                  n > s &&
                  ((n = s), this.showInventoryError(t, `Only ${s} available`)),
                  (n === r && o.value === String(n)) ||
                    ((o.value = n), this.requestQuantityUpdate(t, n)));
              },
              u = (e) => {
                ((8 !== e.which && 0 !== e.which && e.which < 48) ||
                  e.which > 57) &&
                  e.preventDefault();
              };
            (s && ((s._clickHandler = c), s.addEventListener("click", c)),
              a && ((a._clickHandler = l), a.addEventListener("click", l)),
              (o._changeHandler = d),
              o.addEventListener("change", d),
              (o._keypressHandler = u),
              o.addEventListener("keypress", u));
          }
          async changeCartItem(e) {
            const t = {
              ...(0, n.Q2)(),
              body: JSON.stringify({
                line: +e.id,
                quantity: e.quantity,
                sections: "main-cart",
              }),
            };
            return fetch(`${routes.cartChange}`, t)
              .then((e) => {
                if (!e.ok && 429 === e.status) {
                  const e = new Error("Rate limited");
                  throw ((e.status = 429), e);
                }
                if (!e.ok && 422 === e.status) {
                  const e = new Error("Item already deleted or invalid");
                  throw ((e.status = 422), e);
                }
                if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`);
                return e.json();
              })
              .then(async (t) => {
                const i = async (i, n) => {
                  let r = this.parser.parseFromString(i, "text/html");
                  if (n && t.item_count > 0) {
                    const t = r.querySelector(
                        `.cart-item[data-item-id="${n}"]`,
                      ),
                      i = t && t.querySelector(".cart-item__totals"),
                      s = i && i.querySelector(".price-item--sale"),
                      a = document.querySelector(
                        `.cart-item[data-item-id="${n}"]`,
                      ),
                      o = a && a.querySelector(".cart-item__totals"),
                      c = o && o.querySelector(".price-item--sale");
                    if (s || c) {
                      const i = e.quantity,
                        s = t && t.querySelector('input[name="quantity"]'),
                        a = (s && parseInt(s.value)) || 1;
                      if (t && a === i);
                      else {
                        const e = this._getCartContainers();
                        let t = null;
                        for (const { searchContainer: i } of e) {
                          const e = i.querySelector(
                            `${this.selectors.cartItem}[data-item-id="${n}"]`,
                          );
                          if (e) {
                            let i = e.querySelector(
                              ".text-md.show-desktop " +
                                this.selectors.priceItemSale,
                            );
                            if (
                              (i ||
                                (i = e.querySelector(
                                  ".text-md " + this.selectors.priceItemSale,
                                )),
                              !i)
                            ) {
                              const t = e.querySelectorAll(
                                this.selectors.priceItemSale,
                              );
                              for (const e of t)
                                if (!e.closest(this.selectors.cartItemTotals)) {
                                  i = e;
                                  break;
                                }
                            }
                            if (i) {
                              const e = i.textContent
                                .trim()
                                .replace(/[^\d.,]/g, "");
                              if (e.includes(",") && !e.includes("."))
                                t = parseFloat(e.replace(",", "."));
                              else if (e.includes(",") && e.includes(".")) {
                                const i = e.split(",");
                                t =
                                  2 === i.length && i[1].length <= 2
                                    ? parseFloat(
                                        e.replace(/\./g, "").replace(",", "."),
                                      )
                                    : parseFloat(e.replace(/,/g, ""));
                              } else t = parseFloat(e.replace(/,/g, ""));
                              if (!isNaN(t)) break;
                            }
                          }
                        }
                        if (null !== t) {
                          const e = t * i;
                          ((r._needsManualPriceCalc = !0),
                            (r._calculatedLinePrice = e),
                            (r._requestedQty = i));
                        }
                      }
                    }
                  }
                  if (0 === t.item_count) {
                    console.log("[Cart] Cart is empty, rendering empty state");
                    const e = document.querySelector(this.mainCartSelector);
                    if (e) {
                      const t = r.querySelector(this.mainCartSelector);
                      t
                        ? (console.log(
                            "[Cart] Updating main cart with empty state HTML",
                          ),
                          (e.innerHTML = t.innerHTML))
                        : console.warn(
                            `[Cart] Could not find main cart selector "${this.mainCartSelector}" in parsed content`,
                          );
                    } else
                      console.log("[Cart] No main cart element found on page");
                    this.renderElements(r);
                  } else if ((this.renderElements(r), n)) {
                    const e = r._needsManualPriceCalc
                      ? {
                          calculatedLinePrice: r._calculatedLinePrice,
                          requestedQty: r._requestedQty,
                        }
                      : null;
                    await this.patchLineItem(n, r, e);
                  }
                  this.restoreOptimisticQuantities();
                };
                if (t.sections && null !== t.sections["main-cart"])
                  await i(t.sections["main-cart"], e.itemKey);
                else {
                  const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`;
                  await fetch(t)
                    .then((e) => e.text())
                    .then(async (t) => {
                      await i(t, e.itemKey);
                    });
                }
                const n = `${window.location.pathname}?section_id=navigation-main`;
                return fetch(n)
                  .then((e) => e.text())
                  .then((e) => {
                    if (
                      (this.parser.parseFromString(e, "text/html"),
                      0 === t.item_count)
                    ) {
                      console.log(
                        "[Cart] Cart is now empty, manually updating mini-cart to empty state",
                      );
                      const e = document.querySelector("#mini-cart");
                      if (e) {
                        const t = e.querySelector(".cart-items-container");
                        t &&
                          (console.log("[Cart] Hiding cart-items-container"),
                          (t.style.display = "none"),
                          t.remove());
                        let i = e.querySelector(".mini-cart--empty");
                        if (i)
                          (console.log(
                            "[Cart] Found existing mini-cart--empty, making it visible",
                          ),
                            (i.style.display = "block"));
                        else {
                          console.log(
                            "[Cart] No mini-cart--empty found, checking mini-cart__content",
                          );
                          const t = e.querySelector(".mini-cart__content");
                          t &&
                            ((i = t.querySelector(".mini-cart--empty")),
                            i &&
                              (console.log(
                                "[Cart] Found mini-cart--empty in content, making visible",
                              ),
                              (i.style.display = "block")));
                        }
                        (e.querySelectorAll(".cart-count").forEach((e) => {
                          e.textContent = "0";
                        }),
                          e
                            .querySelectorAll(".cart-total-price")
                            .forEach((e) => {
                              e.textContent = "$0.00";
                            }));
                        const n = e.querySelector("#checkout");
                        n && (n.disabled = !0);
                        const r = e.querySelector(
                          ".cart-summary__free-shipping",
                        );
                        (r &&
                          ((r.style.display = "none"),
                          console.log(
                            "[Cart] Hidden free shipping calculator for empty cart",
                          )),
                          console.log(
                            "[Cart] ✓ Mini-cart manually updated to empty state",
                          ));
                      } else
                        console.log(
                          "[Cart] No mini-cart element found on page",
                        );
                    }
                    return t;
                  });
              })
              .catch((e) => {
                throw (console.error(e), e);
              });
          }
          renderElements(e) {
            this.selectorsToUpdate.forEach((t) => {
              try {
                const i = document.querySelectorAll(t),
                  n = e.querySelector(t);
                i.length &&
                  n &&
                  (n
                    .querySelectorAll(".icon")
                    .forEach((e) => e.classList.add("loaded")),
                  i.forEach((e) => {
                    e.innerHTML = n.innerHTML;
                  }));
              } catch (e) {
                console.error(`Error updating ${t}`, e);
              }
            });
            const checkoutSrc = e.querySelector('#checkout');
            document.querySelectorAll('#checkout').forEach((atc) => {
              if (checkoutSrc) {
                checkoutSrc.hasAttribute("disabled")
                ? atc.setAttribute("disabled", "")
                : atc.removeAttribute("disabled");
              }
            })
            const t = e.querySelector(".cart-total-price");
            if (t) {
              const e = [],
                i = document.querySelector(this.mainCartSelector);
              (i && e.push(i),
                this.miniCart && e.push(this.miniCart),
                e.forEach((e) => {
                  const i = e.querySelector(".cart-total-price");
                  i && (i.innerHTML = t.innerHTML);
                }));
            }
            const i = e.querySelector(".cart-count");
            (document
              .querySelectorAll(
                "#cart-open-block .header__icons--cart-open .cart-count",
              )
              .forEach((e) => {
                i
                  ? (e.classList.contains("visually-hidden") &&
                      e.classList.remove("visually-hidden"),
                    (e.textContent = i.textContent))
                  : e.classList.add("visually-hidden");
              }),
              document
                .querySelector("#cart-open-block .icon")
                .classList.add("loaded"));
          }
          renderItems(e) {
            this.renderElements(e);
            const t = Array.from(
                document.querySelectorAll(this.itemsContainersSelector),
              ),
              i = e.querySelector(this.itemsContainersSelector);
            (t.forEach((e) => {
              e && e.replaceWith(i.cloneNode(!0));
            }),
              document.querySelectorAll(".cart-item").forEach((e) => {
                (e
                  .querySelectorAll(".icon")
                  .forEach((e) => e.classList.add("loaded")),
                  this.manageState(e));
              }));
          }
          updateMiniCart(e) {
            return fetch(
              `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
            )
              .then((e) => e.text())
              .then((t) => {
                (this.renderItems(
                  new DOMParser().parseFromString(t, "text/html"),
                ),
                  e &&
                    "mini-cart" === cartStrings.uxCart &&
                    this.miniCart &&
                    this.miniCart.open());
              })
              .catch((e) => {
                console.error("Error updating mini cart:", e);
              });
          }
        })();
        ((window.cartService = r),
          (window.updateMiniCart = function () {
            return r.updateMiniCart(...arguments);
          }),
          (t.Z = r),
          customElements.get("cart-note") ||
            customElements.define(
              "cart-note",
              class extends HTMLElement {
                constructor() {
                  (super(),
                    this.querySelector("textarea").addEventListener(
                      "change",
                      (0, n.Ds)((e) => {
                        const t = JSON.stringify({ note: e.target.value });
                        fetch(`${routes.cartUpdate}`, {
                          ...(0, n.Q2)(),
                          body: t,
                        });
                      }, 300),
                    ));
                }
              },
            ));
      },
      1717: function (e, t, i) {
        "use strict";
        i.d(t, {
          f: function () {
            return s;
          },
        });
        var n = i(6072),
          r = i(4487);
        const s = () => {
          const e = document.querySelectorAll(
              'form[data-type="add-to-cart-form"]',
            ),
            t = document.getElementById("main-cart"),
            i = document.getElementById("mini-cart"),
            s = document.querySelector("body");
          e.length &&
            e.forEach((e) =>
              e.addEventListener("submit", (a) => {
                (a.preventDefault(),
                  a.stopPropagation(),
                  a.target.querySelector(
                    'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                  ) &&
                    (a.target.querySelector(
                      'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                    ).textContent = `${cartStrings.addingToCart}`));
                const o = a.target.querySelector('button[type="submit"]'),
                  c = o.querySelector("span.cart-icon"),
                  l = o.querySelector("svg.loading-icon");
                (s.classList.remove("added-to-cart"),
                  o.classList.add("added"),
                  (c.style.display = "none"),
                  (l.style.display = "block"));
                const d = (0, n.Q2)("javascript");
                ((d.headers["X-Requested-With"] = "XMLHttpRequest"),
                  delete d.headers["Content-Type"]);
                const u = new FormData(e);
                (u.append("sections", "main-cart"),
                  (d.body = u),
                  fetch(`${routes.cartAdd}`, d)
                    .then((e) => e.json())
                    .then(async (e) => {
                      if (e.status) {
                        if (
                          (r.Z.updateMiniCart(!0),
                          (c.style.display = "inline-flex"),
                          (l.style.display = "none"),
                          a.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                          ) &&
                            (a.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                            ).textContent = `${cartStrings.addToCart}`),
                          "object" == typeof e.description)
                        )
                          return Object.entries(e.description).forEach((e) => {
                            let [t, i] = e;
                            const n = `${i.join(", ")}`;
                            a.target.querySelector(
                              ".main-product__error",
                            ).innerHTML =
                              '<span class="icon loaded">error</span><p>' +
                              n +
                              "</p>";
                          });
                        a.target.querySelector(
                          ".main-product__error",
                        ).innerHTML =
                          '<span class="icon loaded">error</span><p>' +
                          e.description +
                          "</p>";
                      } else {
                        if ("cart" === cartStrings.uxCart)
                          return void (window.location.href =
                            window.routes.cart);
                        if (
                          ((a.target.querySelector(
                            ".main-product__error",
                          ).innerHTML = ""),
                          t && t.classList.add("added"),
                          e.sections && null !== e.sections["main-cart"])
                        )
                          r.Z.renderItems(
                            new DOMParser().parseFromString(
                              e.sections["main-cart"],
                              "text/html",
                            ),
                          );
                        else {
                          const e = `${window.location.pathname}?section_id=main-cart`;
                          fetch(e)
                            .then((e) => e.text())
                            .then((e) => {
                              r.Z.renderItems(
                                new DOMParser().parseFromString(e, "text/html"),
                              );
                            });
                        }
                        ("mini-cart" === cartStrings.uxCart && i && i.open(),
                          a.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                          ) &&
                            (a.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                            ).textContent = `${cartStrings.addedToCart}`),
                          o.classList.remove("added"),
                          o.classList.add("successful"),
                          (c.style.display = "flex"),
                          (l.style.display = "none"),
                          s.classList.add("added-to-cart"));
                      }
                    })
                    .catch((e) => {
                      console.error("Error:", e);
                    }));
              }),
            );
        };
      },
      6072: function (e, t, i) {
        "use strict";
        i.d(t, {
          Ds: function () {
            return s;
          },
          Q2: function () {
            return n;
          },
          hO: function () {
            return r;
          },
          zx: function () {
            return o;
          },
        });
        const n = function () {
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
              },
            };
          },
          r = function () {
            let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const t = window.innerWidth - document.body.offsetWidth,
              i = document.getElementById("nav-wrapper");
            e
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = t + "px"),
                (i.style.paddingRight = t + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (i.style.paddingRight = "0px"));
          };
        function s(e, t) {
          const i = this;
          let n;
          return function () {
            for (var r = arguments.length, s = new Array(r), a = 0; a < r; a++)
              s[a] = arguments[a];
            (clearTimeout(n),
              (n = setTimeout(function () {
                return e.apply(i, s);
              }, t)));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            (e.preventDefault(), e.stopPropagation());
            const t = e.target.getAttribute("href");
            !(function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const i = document.getElementById("nav-wrapper"),
                n = document
                  .querySelector(".header")
                  .getAttribute("data-ux-position"),
                r = e.getBoundingClientRect().top;
              window.scrollTo({
                top:
                  "off" !== n
                    ? r + window.scrollY - t + parseFloat(i.style.marginTop)
                    : r + window.scrollY - t,
                behavior: "smooth",
              });
            })(document.querySelector(t));
          });
        });
        const a = {};
        function o(e) {
          (document.removeEventListener("focusin", a.focusin),
            document.removeEventListener("focusout", a.focusout),
            document.removeEventListener("keydown", a.keydown),
            e && e.focus());
        }
      },
    },
    t = {};
  function i(n) {
    var r = t[n];
    if (void 0 !== r) return r.exports;
    var s = (t[n] = { exports: {} });
    return (e[n](s, s.exports, i), s.exports);
  }
  ((i.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return (i.d(t, { a: t }), t);
  }),
    (i.d = function (e, t) {
      for (var n in t)
        i.o(t, n) &&
          !i.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      "use strict";
      var e = i(6072),
        t = i(1717);
      (i(1727),
        document.addEventListener("DOMContentLoaded", function () {
          (document.querySelectorAll(".icon").forEach((e) => {
            e.classList.add("loaded");
          }),
            document.querySelectorAll('a[target="_blank"]').forEach((e) => {
              e.innerHTML =
                e.innerHTML +
                '<span class="visually-hidden"> ' +
                accessibilityNoticeNewTab +
                "</span>";
            }),
            (0, t.f)());
        }),
        void 0 !== window.BOOMR &&
          console.log(
            "Built with " +
              window.BOOMR.themeName +
              " (https://themes.shopify.com/themes/align/) version " +
              window.BOOMR.themeVersion +
              " by Company XYZ (https://companyxyz.io/).",
          ),
        void 0 === window.Shopify && (window.Shopify = {}),
        (Shopify.bind = function (e, t) {
          return function () {
            return e.apply(t, arguments);
          };
        }),
        (Shopify.setSelectorByValue = function (e, t) {
          for (var i = 0, n = e.options.length; i < n; i++) {
            var r = e.options[i];
            if (t == r.value || t == r.innerHTML)
              return ((e.selectedIndex = i), i);
          }
        }),
        (Shopify.addListener = function (e, t, i) {
          e.addEventListener
            ? e.addEventListener(t, i, !1)
            : e.attachEvent("on" + t, i);
        }),
        (Shopify.postLink = function (e, t) {
          var i = (t = t || {}).method || "post",
            n = t.parameters || {},
            r = document.createElement("form");
          for (var s in (r.setAttribute("method", i),
          r.setAttribute("action", e),
          n)) {
            var a = document.createElement("input");
            (a.setAttribute("type", "hidden"),
              a.setAttribute("name", s),
              a.setAttribute("value", n[s]),
              r.appendChild(a));
          }
          (document.body.appendChild(r),
            r.submit(),
            document.body.removeChild(r));
        }),
        (Shopify.CountryProvinceSelector = function (e, t, i) {
          ((this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(
              i.hideElement || t,
            )),
            Shopify.addListener(
              this.countryEl,
              "change",
              Shopify.bind(this.countryHandler, this),
            ),
            this.initCountry(),
            this.initProvince());
        }),
        (Shopify.CountryProvinceSelector.prototype = {
          initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            (Shopify.setSelectorByValue(this.countryEl, e),
              this.countryHandler());
          },
          initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e &&
              this.provinceEl.options.length > 0 &&
              Shopify.setSelectorByValue(this.provinceEl, e);
          },
          countryHandler: function (e) {
            var t = (r =
                this.countryEl.options[
                  this.countryEl.selectedIndex
                ]).getAttribute("data-provinces"),
              i = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
              this.provinceContainer.style.display = "none";
            else {
              for (var n = 0; n < i.length; n++) {
                var r;
                (((r = document.createElement("option")).value = i[n][0]),
                  (r.innerHTML = i[n][1]),
                  this.provinceEl.appendChild(r));
              }
              this.provinceContainer.style.display = "";
            }
          },
          clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
          },
          setOptions: function (e, t) {
            var i = 0;
            for (t.length; i < t.length; i++) {
              var n = document.createElement("option");
              ((n.value = t[i]), (n.innerHTML = t[i]), e.appendChild(n));
            }
          },
        }),
        document.querySelectorAll("video").forEach((e) => {
          ((e.muted = !0),
            new IntersectionObserver(
              (t) => {
                t.forEach((t) => {
                  t.isIntersecting
                    ? 1 == e.autoplay &&
                      e.paused &&
                      e.play().catch((e) => {
                        "AbortError" !== e.name &&
                          console.error("Error playing video:", e);
                      })
                    : e.pause();
                });
              },
              { threshold: 0 },
            ).observe(e));
        }),
        document.querySelectorAll("video.hover-play").forEach((e) => {
          const t = e.closest(".card");
          (e.pause(),
            t
              ? (t.addEventListener("mouseenter", () => {
                  e.play().catch((e) => {
                    "AbortError" !== e.name &&
                      console.error("Error playing video:", e);
                  });
                }),
                t.addEventListener("mouseleave", () => {
                  e.pause();
                }))
              : (e.addEventListener("mouseenter", () => {
                  e.play().catch((e) => {
                    "AbortError" !== e.name &&
                      console.error("Error playing video:", e);
                  });
                }),
                e.addEventListener("mouseleave", () => {
                  e.pause();
                })));
        }));
      const n = function () {
        [].slice.call(document.querySelectorAll("video")).forEach((e) => {
          const t = e.parentElement.querySelector(".figure--video__poster");
          t &&
            t.addEventListener("click", () => {
              (t.classList.add("hidden"), e.play());
            });
        });
        var e = [].slice.call(
          document.querySelectorAll(".figure--video-external"),
        );
        if ("IntersectionObserver" in window) {
          var t = new IntersectionObserver(function (e, t) {
            e.forEach(function (e) {
              if (e.isIntersecting)
                ("vimeo" == e.target.dataset.type &&
                  fetch(
                    "http://vimeo.com/api/v2/video/" +
                      e.target.dataset.id +
                      ".json",
                  )
                    .then((e) => {
                      if (!e.ok) throw new Error(`HTTP error ${e.status}`);
                      return e.json();
                    })
                    .then((t) => {
                      e.target.querySelector(
                        ".figure--video__external-poster-image",
                      ).src = t[0].thumbnail_large;
                    }),
                  e.target.addEventListener("click", function () {
                    if (!e.target.querySelector("iframe")) {
                      let e = this.dataset.type,
                        t = document.createElement("iframe");
                      (t.setAttribute("frameborder", "0"),
                        t.setAttribute("allowfullscreen", ""),
                        t.setAttribute("allow", "autoplay"),
                        "youtube" == e
                          ? (t.setAttribute("id", "youtube"),
                            t.setAttribute(
                              "src",
                              "https://www.youtube.com/embed/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1",
                            ))
                          : t.setAttribute(
                              "src",
                              "https://player.vimeo.com/video/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1",
                            ),
                        this.appendChild(t),
                        setTimeout(() => {
                          this.querySelector(
                            ".figure--video__poster",
                          ).classList.add("hidden");
                        }, 350));
                    }
                  }));
              else if (e.target.querySelector("iframe")) {
                let i = e.target.dataset.type,
                  n = e.target.querySelectorAll("iframe");
                if ("youtube" == i) {
                  var t = { event: "command", func: "pauseVideo" };
                  n[0].contentWindow.postMessage(JSON.stringify(t), "*");
                } else
                  "vimeo" == i &&
                    ((t = { method: "pause", value: "true" }),
                    n[0].contentWindow.postMessage(JSON.stringify(t), "*"));
              }
            });
          });
          e.forEach(function (e) {
            t.observe(e);
          });
        }
      };
      (n(),
        window.addEventListener("beforeprint", () => {
          const e = document.body.querySelectorAll("details"),
            t = document.body.querySelectorAll("img");
          for (let t = 0; t < e.length; t++)
            e[t].open
              ? (e[t].dataset.open = "1")
              : e[t].setAttribute("open", "");
          for (let e = 0; e < t.length; e++) t[e].dataset.open = "1";
        }),
        window.addEventListener("afterprint", () => {
          const e = document.body.querySelectorAll("details");
          for (let t = 0; t < e.length; t++)
            e[t].dataset.open
              ? (e[t].dataset.open = "")
              : e[t].removeAttribute("open");
        }),
        Shopify.designMode &&
          document.addEventListener("shopify:section:load", () => {
            (n(),
              document.querySelectorAll(".icon").forEach((e) => {
                e.classList.add("loaded");
              }));
          }));
      class r extends HTMLElement {
        constructor() {
          (super(),
            this.addEventListener("change", (e) => {
              const t = new CustomEvent("variant-update", {
                detail: {
                  event: e,
                  section: this.dataset.section,
                  product: this.dataset.product,
                  block: this.dataset.block,
                },
                bubbles: !0,
              });
              this.dispatchEvent(t);
            }),
            document.addEventListener("variant-update", (e) => {
              this.dataset.section === e.detail.section &&
                this.dataset.product === e.detail.product &&
                this.dataset.block === e.detail.block &&
                (e.detail.event.target.closest("variant-selects") !== this &&
                  this.syncSelection(e.detail.event.target),
                this.onVariantChange());
            }),
            (this.isCardBasedProductForm =
              null !== this.closest(".card__content")));
        }
        connectedCallback() {
          ((this.mainProductUniqueIdentifier =
            "main-product-" + this.dataset.product),
            (this.uniqueIdentifier =
              this.dataset.section +
              "-" +
              this.dataset.product +
              (this.dataset.block ? "-" + this.dataset.block : "")));
        }
        onVariantChange() {
          (this.updateOptions(),
            this.updateMasterId(),
            this.currentVariant
              ? (this.updateVariantStatuses(),
                this.updateImageSwatches(),
                this.updateMedia(),
                this.updateURL(),
                this.updateLinks(),
                this.renderProductInfo(),
                this.updateVariantInput(),
                this.updateAddToCart())
              : void 0 === this.currentVariant && this.setUnavailable());
        }
        syncSelection(e) {
          const { name: t, value: i } = e,
            n = this.querySelector(`[name="${t}"]`),
            r = n?.tagName;
          n &&
            ("SELECT" === r
              ? (this.querySelector(`[name="${t}"] [value="${i}"]`).selected =
                  !0)
              : (this.querySelector(`[name="${t}"][value="${i}"]`).checked =
                  !0));
        }
        updateOptions() {
          this.options = Array.from(
            this.querySelectorAll("select, fieldset"),
            (e) =>
              "SELECT" === e.tagName
                ? e.value
                : "FIELDSET" === e.tagName
                  ? Array.from(e.querySelectorAll("input")).find(
                      (e) => e.checked,
                    )?.value
                  : void 0,
          );
        }
        updateMasterId() {
          this.options.includes(void 0)
            ? (this.currentVariant = null)
            : (this.currentVariant = this.getVariantData().find(
                (e) =>
                  !e.options.map((e, t) => this.options[t] === e).includes(!1),
              ));
        }
        updateVariantStatuses() {
          const e = this.querySelector(":checked").value,
            t = this.getVariantData().filter((t) => t.options[0] === e);
          this.getProductVariantSelects().forEach((e) => {
            const i = e.querySelectorAll("select, fieldset");
            i.forEach((e, n) => {
              if (0 === n) return;
              const r = e.querySelectorAll('input[type="radio"], option'),
                s = i[n - 1].querySelector(":checked").value,
                a = t
                  .filter((e) => e.available && e[`option${n}`] === s)
                  .map((e) => e[`option${n + 1}`]);
              this.setInputAvailability(r, a);
            });
          });
        }
        setInputAvailability(e, t) {
          e.forEach((e) => {
            const i = e.getAttribute("value"),
              n = t.includes(i);
            "OPTION" === e.tagName &&
              (e.innerText = n
                ? i
                : window.productStrings.unavailable_with_option.replace(
                    "[value]",
                    i,
                  ));
          });
        }
        updateImageSwatches() {
          this.querySelectorAll("fieldset:has(.image-swatch)").forEach((e) => {
            const t = e.dataset.optionPosition,
              i = e.querySelectorAll(".image-swatch");
            for (const e of i) {
              const i = [...this.options];
              i[t - 1] = e.value;
              const n = this.getVariantData().find(
                (e) =>
                  e.options[0] == i[0] &&
                  e.options[1] == i[1] &&
                  e.options[2] == i[2],
              );
              if (!n) continue;
              const r = e.labels[0],
                s = r.querySelectorAll("img.variant-image"),
                a = r.querySelector(`img[data-variant-id="${n.id}"]`),
                o = r.querySelector(".image_swatch--text_value");
              (s.forEach((e) => {
                e.classList.add("hidden");
              }),
                o.classList.add("u-hide"),
                a
                  ? a.classList.remove("hidden")
                  : o.classList.remove("u-hide"));
            }
          });
        }
        updateMedia() {
          if (!this.currentVariant) return;
          if (!this.currentVariant.featured_media) return;
          const e = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
            t = e.dataset.variantStyle;
          if (this.currentVariant.featured_media) {
            const i = this.currentVariant.featured_media.id;
            if ("default" == t)
              if (e.swiper.initialized) {
                const t = e.swiper.virtual?.slides?.length
                    ? e.swiper.virtual.slides
                    : e.swiper.slides,
                  n = Array.from(t).findIndex((e) => e.dataset.id == i);
                -1 !== n && e.swiper.slideToLoop(n);
              } else {
                const t = e.querySelector(`[data-id="${i}"]`);
                t && e.prepend(t);
              }
            else if ("variant" == t) {
              const t = e.querySelector(`[data-id="${i}"]`);
              t &&
                (e.firstChild.classList.add("u-hide"),
                t.classList.remove("u-hide"),
                e.prepend(t));
            }
            const n = document.querySelector(
              `#sticky-gallery-${this.uniqueIdentifier}`,
            );
            if (n) {
              const e = n.querySelectorAll(".sticky-add-to-cart__image"),
                t = this.currentVariant.id;
              e.forEach((e) => {
                e.dataset.variantId == t
                  ? e.classList.remove("u-hide")
                  : e.classList.add("u-hide");
              });
            }
          }
        }
        updateURL() {
          if ("false" === this.dataset.updateUrl) return;
          const e = `${this.dataset.url}?variant=${this.currentVariant.id}`;
          window.history.replaceState({}, "", e);
        }
        updateLinks() {
          if (!this.isCardBasedProductForm) return;
          const e = this.closest(".card__content").querySelector(
            ".button--view-product",
          );
          "A" === e?.tagName &&
            (e.href =
              this.dataset.url.split("?")[0] +
              `?variant=${this.currentVariant.id}`);
        }
        updateVariantInput() {
          document
            .querySelectorAll(
              `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`,
            )
            .forEach((e) => {
              const t = e.querySelector('input[name="id"]');
              ((t.value = this.currentVariant.id),
                t.dispatchEvent(new Event("change", { bubbles: !0 })));
            });
        }
        renderProductInfo() {
          const t = document.getElementById(`price-${this.uniqueIdentifier}`);
          t &&
            (t.classList.contains("price--on-sale")
              ? t
                  .querySelectorAll(".price__sale .price-item")
                  .forEach((e) => e.classList.add("skeleton-loading"))
              : t
                  .querySelector(".price__regular")
                  .classList.add("skeleton-loading"));
          const i = document.getElementById(
            `sticky-price-${this.uniqueIdentifier}`,
          );
          i &&
            (i.classList.contains("price--on-sale")
              ? i
                  .querySelectorAll(".price__sale .price-item")
                  .forEach((e) => e.classList.add("skeleton-loading"))
              : i
                  .querySelector(".price__regular")
                  .classList.add("skeleton-loading"));
          const n = document.getElementById(
            `pickup-availability-${this.uniqueIdentifier}`,
          );
          n?.querySelector(".skeleton-loading-wrapper")?.classList.add(
            "skeleton-loading",
          );
          const r = document.getElementById(
            `stock-status-${this.uniqueIdentifier}`,
          );
          r?.classList.add("skeleton-loading");
          const s = document.getElementById(
            `pickup-availability-modal-${this.uniqueIdentifier}`,
          );
          fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
            .then((e) => e.text())
            .then((a) => {
              const o = new DOMParser().parseFromString(a, "text/html"),
                c = o.getElementById(
                  `price-${this.mainProductUniqueIdentifier}`,
                );
              if (r) {
                const e = o.getElementById(
                  `stock-status-${this.mainProductUniqueIdentifier}`,
                );
                e
                  ? (r.classList.remove("u-invisible"),
                    (r.innerHTML = e.innerHTML),
                    (r.classList = e.classList))
                  : r?.classList.add("u-invisible");
              }
              if (
                (c && t
                  ? (t.classList.remove("u-invisible"),
                    (t.innerHTML = c.innerHTML),
                    (t.classList = c.classList))
                  : t?.classList.add("u-invisible"),
                i)
              ) {
                const e = o.getElementById(
                  `sticky-price-${this.mainProductUniqueIdentifier}`,
                );
                e
                  ? (i.classList.remove("u-invisible"),
                    (i.innerHTML = e.innerHTML),
                    (i.classList = e.classList))
                  : i?.classList.add("u-invisible");
              }
              if (n) {
                const e = o.getElementById(
                  `pickup-availability-${this.mainProductUniqueIdentifier}`,
                );
                e && ((n.innerHTML = e.innerHTML), (n.classList = e.classList));
              }
              if (s) {
                const e = o.getElementById(
                  `pickup-availability-modal-${this.mainProductUniqueIdentifier}`,
                );
                e && (s.innerHTML = e.innerHTML);
              }
              const l = document.querySelector(".pickup-availability"),
                d = document.getElementById("overlay"),
                u = document.getElementById("pickup-availability-open"),
                h = document.getElementById("pickup-availability-close");
              (u &&
                document
                  .getElementById("pickup-availability-open")
                  .addEventListener("click", function () {
                    (l.classList.add("open"),
                      d.classList.add("open"),
                      document.body.classList.add("active", "minicart"),
                      (0, e.hO)(!0));
                  }),
                h &&
                  document
                    .getElementById("pickup-availability-close")
                    .addEventListener("click", function () {
                      (l.classList.remove("open"),
                        document.body.classList.remove("active", "minicart"),
                        (0, e.hO)(!1),
                        overlay.classList.remove("open", "overlay--all"),
                        (0, e.zx)(l));
                    }));
            });
        }
        updateAddToCart() {
          const e = document.querySelectorAll(
            `.form-product-${this.uniqueIdentifier}`,
          );
          e &&
            (this.currentVariant.available
              ? e.forEach((e) => {
                  const t = e.querySelector('[name="add"]'),
                    i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                  t &&
                    (t.removeAttribute("disabled"),
                    (i.textContent = `${cartStrings.addToCart}`));
                })
              : e.forEach((e) => {
                  const t = e.querySelector('[name="add"]'),
                    i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                  t &&
                    (t.setAttribute("disabled", "disabled"),
                    (i.textContent = `${cartStrings.soldOut}`));
                }));
        }
        setUnavailable() {
          const e = document.querySelectorAll(
              `.form-product-${this.uniqueIdentifier}`,
            ),
            t = document.getElementById(
              `stock-status-${this.uniqueIdentifier}`,
            );
          e.forEach((e) => {
            const i = e.querySelector('[name="add"]'),
              n = e.querySelector('[name="add"] > span:not(.cart-icon)');
            i &&
              ((n.textContent = `${cartStrings.unavailable}`),
              i.setAttribute("disabled", "disabled"),
              t && (t.dataset.state = "unavailable"));
          });
          const i = document.getElementById(`price-${this.uniqueIdentifier}`),
            n = document.getElementById(
              `sticky-price-${this.uniqueIdentifier}`,
            );
          (i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n));
        }
        setPriceUnavailable(e) {
          (e.classList.remove("price--on-sale"),
            e.classList.add("price--sold-out"),
            (e.querySelector(
              ".price__regular .price-item.price-item--regular",
            ).textContent = window.productStrings.price_unavailable));
        }
        getVariantData() {
          return (
            (this.variantData =
              this.variantData ||
              JSON.parse(
                this.querySelector('[type="application/json"]').textContent,
              )),
            this.variantData
          );
        }
        getProductVariantSelects() {
          return document.querySelectorAll(
            `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`,
          );
        }
      }
      customElements.get("variant-selects") ||
        customElements.define("variant-selects", r);
      class s {
        constructor(e) {
          ((this.el = e),
            (this.summary = e.querySelector("summary")),
            (this.content = e.querySelector(".content")),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            this.summary.addEventListener("click", (e) => this.onClick(e)));
        }
        onClick(e) {
          (e.preventDefault(),
            (this.el.style.overflow = "hidden"),
            this.isClosing || !this.el.open
              ? this.open()
              : (this.isExpanding || this.el.open) && this.shrink());
        }
        shrink() {
          this.isClosing = !0;
          const e = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight}px`;
          (this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [e, t] },
              { duration: 400, easing: "ease-out" },
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
            (this.animation.oncancel = () => (this.isClosing = !1)));
        }
        open() {
          ((this.el.style.height = `${this.el.offsetHeight}px`),
            (this.el.open = !0),
            window.requestAnimationFrame(() => this.expand()));
        }
        expand() {
          this.isExpanding = !0;
          const e = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
          (this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [e, t] },
              { duration: 400, easing: "ease-out" },
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
            (this.animation.oncancel = () => (this.isExpanding = !1)));
        }
        onAnimationFinish(e) {
          ((this.el.open = e),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            (this.el.style.height = this.el.style.overflow = ""));
        }
      }
      document.querySelectorAll("details.accordion__wrapper").forEach((e) => {
        new s(e);
      });
    })());
})();
